import { Component, AfterContentChecked, Optional, Inject, ViewChild, OnInit } from '@angular/core';
import { PershingTranslationService, PershingHttpUtil } from '@pershing/pershing-core';
import { TemplatePortalDirective } from '@angular/cdk/portal';
import { Overlay, CdkOverlayOrigin, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { LoginReviewDialogComponent } from '../LoginReviewTemplate/login-review-dialog';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { Router } from '@angular/router';
import { NXICommonConstants } from '../../utils/nxi-common.constant';

const LANGUAGES = [
    { 'key': 'en_US', 'label': 'English' },
    { 'key': 'es_LA', 'label': 'Español' }
];

@Component({
    selector: 'language-switch',
    templateUrl: './language-switch.component.html'
})
export class LanguageSwitchComponent implements OnInit, AfterContentChecked {
    themeType: string;
    languages = LANGUAGES;
    showPopup: boolean = false;
    locale: string;
    isMobile: boolean = false;
    isTablet: boolean = false;
    isSpanishEnabledIBD: boolean = false;
    isLoggedInUser: boolean = false;
    isGeneric: boolean = false;
    showPreloginPageLink: boolean = false;
    showSpanishLink: boolean = false;
    showEnglishLink: boolean = false;
    brandedurl: any;
    @ViewChild('langPopupOrigin') langPopupOrigin: CdkOverlayOrigin;
    @ViewChild('langPopupTemplate') langPopupTemplate: TemplatePortalDirective;
    overlayRef: OverlayRef;

    constructor(@Optional() @Inject('AppSettings') appSettings: any, private translationService: PershingTranslationService, public overlay: Overlay,
                private dialog: MatDialog, private nxiRestService: NxiRestService, private router: Router) {
        if (appSettings.themeType && appSettings.themeType === 'ada') {
            this.themeType = 'ada';
        } else if (appSettings.themeType && appSettings.themeType === 'modern') {
            this.themeType = 'modern';
        } else {
            this.themeType = 'standard';
        }
        if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
            this.isMobile = true;
        }
        if (appSettings.deviceType && appSettings.deviceType === 'tablet') {
            this.isTablet = true;
        }
        if (appSettings.locale) {
            this.locale = appSettings.locale;
        }
        let spanishSiteEnabledIBDs = appSettings.ibdConfigMap.spanishSiteEnabledIBD;
        if (spanishSiteEnabledIBDs.includes(appSettings.ibdConfigMap.IBD) || (appSettings.ibdConfigMap.generic && appSettings.ibdConfigMap.community === 'netxinvestor')) {
            this.isSpanishEnabledIBD = true;
        }
        this.isLoggedInUser = appSettings.isLoggedIn;
        this.isGeneric = appSettings.ibdConfigMap.generic;
        let currRoute = window.location.pathname;
        this.router.events.subscribe((url: any) => {
            if (url.url) {
                currRoute = url.url;
            }
            let urlArray = currRoute.split('/');
            if (urlArray[urlArray.length - 1].split('?').length > 1) {
                urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split('?')[0];
            } else if (urlArray[urlArray.length - 1].split('#').length > 1) {
                urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split('#')[0];
            } else if (urlArray[urlArray.length - 1].split(';').length > 1) {
                urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split(';')[0];
            }
            let lastIndex = urlArray[urlArray.length - 1];
            if (NXICommonConstants.ShowLanguageSwitchPagesList.indexOf(lastIndex) === -1) {
                this.showPreloginPageLink = true;
            } else {
                this.showPreloginPageLink = false;
            }
        });
        if (this.locale && this.locale === 'es_LA') {
            this.showEnglishLink = true;
            this.showSpanishLink = false;
        } else {
            this.showSpanishLink = true;
            this.showEnglishLink = false;
        }
    }

    ngAfterContentChecked() {
    }

    async switchLanguage(language: string) {
        if (language === 'en_US' && this.isSpanishEnabledIBD && this.isLoggedInUser && this.isGeneric) {
            this.brandedurl = await this.getBrandedURL();
            if (this.brandedurl) {
                this.loginMessageDialog();
                return;
            }
        }
        let url = location.href;
        if (language !== this.locale) {
        let hashTag = null;
        if (url.includes('#')) {
            let tempArray = url.split('#');
            url = tempArray[0];
            hashTag = tempArray[1];
        }
        let tempURL = this.parseURL(url, language);
        if (hashTag) {
            location.href = tempURL + '#' + hashTag;
        } else {
            location.href = tempURL;
        }
        }
    }

    parseURL(url: string, language: string): any {
        let tempArray = url.split('?');
        let baseURL = tempArray[0];
        let qString = tempArray[1];
        let jsonObject = PershingHttpUtil.getJsonObjectFromQueryString(qString);
        jsonObject.lang = language;
        let queryString = PershingHttpUtil.getQueryStringFromJsonObject(jsonObject);
        url = baseURL + '?' + queryString;
        return url;
    }
    openPopup() {
        let strategy = this.overlay.position().connectedTo(this.langPopupOrigin.elementRef, {originX: 'center', originY: 'bottom'}, {overlayX: 'end', overlayY: 'top'} );
        let config = new OverlayConfig({positionStrategy: strategy});
        this.overlayRef = this.overlay.create(config);
        this.overlayRef.attach(this.langPopupTemplate);
        this.showPopup = true;
        if (this.locale) {
            let showLink = this.languages.find(c => c.key !== this.locale);
            setTimeout(function(){document.getElementById(showLink.key)['href'] = 'javascript:void(0)' ;
                 }, 500);
        }
        console.log('opened popup');
    }
    closePopup() {
        if (this.showPopup) {
            this.overlayRef.dispose();
            this.showPopup = false;
            console.log('closed');
        }
    }

    loginMessageDialog(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = '250px';
        dialogConfig.panelClass = ['modal', ''];
        this.dialog.open(LoginReviewDialogComponent, dialogConfig);
    }
    ngOnInit() {}

    getBrandedURL() {
        return this.nxiRestService.getBrandedURL().toPromise();
    }
}
